import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack, Typography, useTheme } from '@mui/material';

export type PlayDailyConfirm = {
  open: boolean;
  dailySet?: number;
  missedDaily?: boolean;
  dailyTheme?: string;
};

type PropTypes = {
  close: () => void;
  handlePlayDailyConfirm: (dailySet?: number, missedDaily?: boolean) => void;
  open: PlayDailyConfirm;
};

export const PlayDailyConfirmationDialog = ({
  close,
  handlePlayDailyConfirm,
  open,
}: PropTypes) => {
  const theme = useTheme();

  return (
    <Dialog open={open.open} onClose={close} maxWidth="sm">
      <DialogTitle>
        <Typography
          variant="h6"
          textAlign={'center'}
          sx={{
            textShadow:
              theme.palette.mode === 'dark'
                ? `0 0 0px ${theme.palette.dailies.main}, 0 0 0px ${theme.palette.dailies.main}, 0px 0px 16px ${theme.palette.dailies.main}`
                : 'none',
          }}
        >
          {open.dailySet === 236 || open.dailySet === 237
            ? `Regarding today's daily...`
            : 'Confirming you want to play your daily'}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        {open.dailySet === 236 || open.dailySet === 237 ? (
          <Stack spacing={2}>
            <Typography>Hello Daily player! We need your help.</Typography>
            <Typography>
              PAR is getting ready to launch a mobile version of the dailies and
              we need feedback. So for this week's Monday and Tuesday Dailies,
              we are preventing Desktop/Laptop play and asking (..err forcing)
              everyone to play the new mobile version.
            </Typography>
            <Typography>
              Go to{' '}
              <Typography
                display={'inline'}
                fontWeight={600}
                color="primary.main"
              >
                mobile.par.live
              </Typography>{' '}
              on your phone. Login and click PLAY to launch the daily.
            </Typography>
            <Typography>
              We are testing two formats: with a buzzer and without
            </Typography>
            <Typography>
              The community stats and streaks will be updated on the regular
              page as usual. But achievements will be skipped for Monday and
              Tuesday. If any streaks are broken because of the mobile daily,
              let the admins know in the Discord.
            </Typography>
            <Typography>Thank you!</Typography>
          </Stack>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          CANCEL
        </Button>
        <Button
          variant="contained"
          onClick={() =>
            handlePlayDailyConfirm(open.dailySet, open.missedDaily)
          }
          fullWidth
          disabled={open.dailySet === 236 || open.dailySet === 237}
        >
          {open.dailySet === 236 || open.dailySet === 237
            ? 'MOBILE ONLY TODAY'
            : 'PLAY!'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
